var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.users,"item-text":item =>
      item.disabled
        ? item.name + ' (disabled)'
        : _vm.usersDisabled.includes(item._id)
        ? item.name + ' (role already assigned)'
        : item.name,"item-value":"_id","item-disabled":item => _vm.usersDisabled.includes(item._id) || item.disabled,"error":_vm.isError,"clearable":"","hide-no-data":"","hide-selected":"","prepend-icon":"mdi-clipboard-account","append-icon":"mdi-chevron-down"},on:{"change":payload => _vm.$emit('change', payload)}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }